// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1al5U","rootSmall":"AddTileButton_rootSmall__L2nhT"};